import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import onSearchPageDidUpdate from '../../common/actions/search/onSearchPageDidUpdate'
import fetchSearchResults from '../../common/actions/searchPage'
import { searchResults as searchResultsSelector } from '../../common/selectors/searchResults'

import { IRootState } from '../../common/reducers'
import { IPageComponent } from '../../typings/pageComponent'
import { IRecommendedSearches } from '../../typings/recommendedSearches'
import { IProxySearchResultsDecorated } from '../../typings/searchResults'
import {
  ISearchHeadings,
  ISearchIngestedContent
} from '../../typings/seoMetadata'
import { IStudioRecommendations } from '../../typings/studioRecommendations'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  results: IProxySearchResultsDecorated
  loading: boolean
  searchHeadings: ISearchHeadings
  studioRecommendations: IStudioRecommendations
  ingestedContent: ISearchIngestedContent | null
  currentSite: string
  relatedSearches: IRecommendedSearches
  user: any
  baseUrl: string
  timeout: boolean
  itemDetailsOpen: boolean
}

interface IDispatchProps {
  onSearchPageDidUpdate: (
    location: any,
    prevUser: any,
    prevResults: any
  ) => void
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    loading,
    ingestedContent,
    relatedSearches,
    timeout,
    studioRecommendations,
    searchHeadings
  } = state.searchPage
  const { currentSite, baseUrl } = state.common
  const { user } = state
  const { selectedItemId } = state.layout

  return {
    results: searchResultsSelector(state),
    loading,
    searchHeadings,
    studioRecommendations,
    ingestedContent,
    currentSite,
    relatedSearches,
    user,
    baseUrl,
    timeout,
    itemDetailsOpen: !!selectedItemId
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
): IDispatchProps => {
  return {
    onSearchPageDidUpdate: (location, prevUser, prevResults) => {
      dispatch(onSearchPageDidUpdate(location, prevUser, prevResults) as any)
    }
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const createSearchPageContainer = (component: React.ComponentType<Props>) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = (store, parsedUrl, opts) => {
    return store.dispatch(fetchSearchResults(parsedUrl, opts))
  }

  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createSearchPageContainer



// WEBPACK FOOTER //
// ./client/containers/searchPageContainer.ts